import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Returns a token that changes whenever:
 *  - the user switches locale, OR
 *  - the browser tab becomes visible again after being hidden.
 *
 * Add it to a useEffect dep array to force a refetch of server data
 * that has localized fields or might have been mutated by another tab/user.
 */
export function useRefetchTrigger() {
    const { i18n } = useTranslation();
    const [visibilityTick, setVisibilityTick] = useState(0);

    useEffect(() => {
        const onVisibility = () => {
            if (document.visibilityState === 'visible') {
                setVisibilityTick((tick) => tick + 1);
            }
        };
        document.addEventListener('visibilitychange', onVisibility);
        return () => document.removeEventListener('visibilitychange', onVisibility);
    }, []);

    return `${i18n.language}:${visibilityTick}`;
}
